export const LANGUAGES = {
  HEBREW: 'he',
  ENGLISH: 'en',
};
